export const TYPES = {
  SELECT_ALL_NOTES: "creditNotesRedeem/SELECT_ALL_NOTES",
};
